/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Auth_Oktaresignin3Inputs */

const en_auth_oktaresignin3 = /** @type {(inputs: Auth_Oktaresignin3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Please sign in using OKTA to continue`)
};

/**
* | output |
* | --- |
* | "Please sign in using OKTA to continue" |
*
* @param {Auth_Oktaresignin3Inputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const auth_oktaresignin3 = /** @type {((inputs?: Auth_Oktaresignin3Inputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Auth_Oktaresignin3Inputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_auth_oktaresignin3(inputs)
});
export { auth_oktaresignin3 as "auth_oktaReSignIn" }